import { INotification } from '@epi-models/components/Notifier';
import { ErrorPopup } from '@epi-models/components/ErrorPopup';

import { PasswordPopupState } from './overlays.slice';

export const getErrorPopup = (state): ErrorPopup => state.overlays.errorPopup;

export const getNotifications = (state): INotification[] =>
  state.overlays.notifications;

export const getPasswordPopup = (state): PasswordPopupState =>
  state.overlays.passwordPopup;

export const getPasswordPopupErrorMessage = (state): string =>
  state.overlays.errorMessage;
